var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.958,
    height: 17.958,
    viewBox: "0 0 17.958 17.958",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_28601",
    "data-name": "Path 28601",
    d: "M10.729,19.458A8.729,8.729,0,1,0,2,10.729,8.737,8.737,0,0,0,10.729,19.458ZM3.971,14.207l3.548-.028a12.636,12.636,0,0,0,1.957,4.041A7.614,7.614,0,0,1,3.971,14.207ZM8.42,8.336h4.421a11.944,11.944,0,0,1,.028,4.688l-4.449.028A11.571,11.571,0,0,1,8.42,8.336Zm2.21,9.56A11.3,11.3,0,0,1,8.7,14.178l3.872-.028A11.9,11.9,0,0,1,10.63,17.9Zm1.126.366a12.414,12.414,0,0,0,1.985-4.125l3.787-.028A7.621,7.621,0,0,1,11.757,18.261Zm6.575-7.532a7.852,7.852,0,0,1-.338,2.253l-3.984.028a12.726,12.726,0,0,0-.028-4.674h3.956A7.484,7.484,0,0,1,18.332,10.729Zm-.873-3.52H13.714A12.946,12.946,0,0,0,11.757,3.2,7.57,7.57,0,0,1,17.459,7.209Zm-4.914,0H8.716A11.632,11.632,0,0,1,10.63,3.563,11.632,11.632,0,0,1,12.545,7.209ZM9.476,3.239a12.51,12.51,0,0,0-1.929,3.97H4A7.576,7.576,0,0,1,9.476,3.239Zm-2.2,5.1a12.954,12.954,0,0,0-.014,4.716l-3.759.028a7.282,7.282,0,0,1-.38-2.351,7.484,7.484,0,0,1,.394-2.393Z",
    transform: "translate(-1.75 -1.75)",
    fill: "#16346c",
    stroke: "#16346c",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeIcon);
export default __webpack_public_path__ + "static/media/globeIcon.34c0005d44a735f54e8d6cb2feda46a1.svg";
export { ForwardRef as ReactComponent };